<template>
  <div class="row">
    <div class="col-lg-6">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-header h-auto border-0">
          <div class="card-title py-5">
            <h3 class="card-label">
              <span class="d-block text-dark font-weight-bolder">Today's Job Data</span>
              <span class="d-block text-muted mt-2 font-size-sm">Glance at the progress for the day</span>
            </h3>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-4 col-sm-12 d-flex flex-column">
              <today-job-listview v-model="todayjob" />
            </div>
            <div class="col-lg-8 col-sm-12">
              <today-job-pie-chart v-model="todayjob" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-6">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-header h-auto border-0">
          <div class="card-title py-5">
            <h3 class="card-label">
              <span class="d-block text-dark font-weight-bolder">Unassigned Trips</span>
              <span class="d-block text-muted mt-2 font-size-sm"
                >Number of unassigned trip for the next 5 days and previous</span
              >
            </h3>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <unassigned-trip-chart v-model="unassignedtrips" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-header h-auto border-0">
          <div class="card-title py-5">
            <h3 class="card-label">
              <span class="d-block text-dark font-weight-bolder">Driver trips</span>
              <span class="d-block text-muted mt-2 font-size-sm">Todays incomplete trip breakdown by driver.</span>
            </h3>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <today-driver-trip-chart v-model="drivertrips" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-8">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-header h-auto border-0">
          <div class="card-title py-5">
            <h3 class="card-label">
              <span class="d-block text-dark font-weight-bolder">Due trips</span>
              <span class="d-block text-muted mt-2 font-size-sm">Trips that are supposed to be completed.</span>
            </h3>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <due-trip-table v-model="duetrips" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted } from "@vue/composition-api";
import { getDashboard } from "@/api/logistics.api";

import TodayJobListview from "@/components/dashboard/TodayJobListview";
import TodayJobPieChart from "@/components/dashboard/TodayJobPieChart";
import UnassignedTripChart from "@/components/dashboard/UnassignedTripChart";
import DueTripTable from "@/components/dashboard/DueTripTable";
import TodayDriverTripChart from "@/components/dashboard/TodayDriverTripChart";
export default {
  components: { TodayJobListview, TodayJobPieChart, UnassignedTripChart, DueTripTable, TodayDriverTripChart },
  setup() {
    onMounted(() => {
      getDashboard().then(response => {
        const data = response.data;
        todayjob.newtrip = data.today_new_trip_count;
        todayjob.ongoingtrip = data.today_ongoing_trip_count;
        todayjob.completedtrip = data.today_completed_trip_count;
        todayjob.failtrip = data.today_fail_trip_count;
        todayjob.canceltrip = data.today_cancel_trip_count;
        todayjob.inactivetrip = data.today_inactive_trip_count;

        unassignedtrips.chartdata = data.total_unassigned_trip;
        duetrips.tabledata = data.due_trips;
        drivertrips.chartdata = data.drivers_chart;
      });
    });

    const todayjob = reactive({
      newtrip: 0,
      ongoingtrip: 0,
      completedtrip: 0,
      failtrip: 0,
      canceltrip: 0,
      inactivetrip: 0
    });

    let unassignedtrips = reactive({
      chartdata: null
    });

    let duetrips = reactive({
      tabledata: null
    });

    let drivertrips = reactive({
      chartdata: null
    });

    return {
      todayjob,
      unassignedtrips,
      duetrips,
      drivertrips
    };
  }
};
</script>
